import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import { TooltipIcon } from 'common/components/TooltipIcon';

type TitleWithInfoIconProps = {
    title: string;
    iconTooltipText?: string;
}

export function TitleWithInfoIcon({ title, iconTooltipText }: Readonly<TitleWithInfoIconProps>) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <Typography
                variant="h6"
                component="span"
                sx={{ fontWeight: 'bold' }}
            >
                {title}
            </Typography>
            <TooltipIcon
                IconComponent={InfoOutlined}
                tooltipTitle={iconTooltipText ?? ''}
                iconColor='action'
                iconInlineStyles={{ marginLeft: '5px' }}
                iconSize='small'
            />
        </div>
    );
}
